import React from 'react'

import { noop } from 'lodash-es'
import { useTheme } from 'styled-components/native'

import { ButtonType } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/baseButton/BaseButton'
import {
  DropdownButton,
  DropdownMenuItem,
} from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/dropdownButton/DropdownButton'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { FILTER_TYPE } from './Medications'

interface StatusFilterProps {
  activeFilter: FILTER_TYPE | null
  onFilterActive: React.Dispatch<React.SetStateAction<FILTER_TYPE>>
  onSelection: (status: string) => void
  selectedStatus?: string
  statuses: string[]
  testID?: string
}

export const StatusFilter: React.FC<StatusFilterProps> = ({
  statuses,
  onSelection,
  selectedStatus,
  testID = 'StatusFilter',
  onFilterActive = noop,
  activeFilter,
}) => {
  const { colors, spacing } = useTheme()
  const dropdownItems: DropdownMenuItem[] = []

  statuses.forEach((status) => {
    dropdownItems.push({
      text: status,
      id: status,
      selectHandler: () => onSelection(status),
    })
  })

  return (
    <DropdownButton
      style={{
        paddingRight: spacing['16px'],
        paddingLeft: spacing['16px'],
        paddingTop: spacing['12px'],
        paddingBottom: spacing['12px'],
        borderRadius: 8,
        backgroundColor: colors.backgroundPrimary,
        marginTop: spacing['4px'],
        borderColor: activeFilter === FILTER_TYPE.STATUS ? colors.borderFocus : colors.borderDefault,
        borderWidth: 1,
        height: 48,
      }}
      testID={tID(testID)}
      dropdownItems={dropdownItems}
      buttonType={ButtonType.SECONDARY}
      dropdownWidth='150px'
      preselectedValue={selectedStatus}
      focusBorderStyle={{ borderRadius: 8 }}
      onPress={() => onFilterActive()}
    />
  )
}

export default StatusFilter
